// Firma Statüsü seçimi (Firma Statüsü listesinden; zorunlu alan)
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const isStoreStatus = (st) => !!st && st.name.toLocaleLowerCase('tr').includes('mağaza');

export const CompanyStatusPicker = ({ value, onChange, error, disabled, onItems, children }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get(`${API}/company-statuses`).then(r => { setItems(r.data); onItems?.(r.data); }).catch(() => setItems([])); }, []);
  const desc = items.find(i => i.id === value)?.description;
  return (
    <div className={`space-y-2 rounded-lg border p-4 ${error ? 'border-rose-400 bg-rose-50/40' : ''}`} data-testid="review-company-status">
      <p className={`text-sm font-medium ${error ? 'text-rose-600' : 'text-slate-700'}`}>Firma Statüsü <span className="text-rose-600">*</span></p>
      <Select value={value || undefined} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className={error ? 'border-2 border-rose-500 ring-2 ring-rose-200' : ''} data-testid="review-company-status-select">
          <SelectValue placeholder="Firma statüsü seçin" />
        </SelectTrigger>
        <SelectContent>
          {items.map(st => <SelectItem key={st.id} value={st.id}>{st.name}</SelectItem>)}
        </SelectContent>
      </Select>
      {error && <p className="text-xs font-semibold text-rose-600" data-testid="review-company-status-error">Firma Statüsü seçmeden firma onaylanamaz.</p>}
      {desc && !error && <p className="text-xs text-slate-500">{desc}</p>}
      {children}
    </div>
  );
};
